<template>
  <el-container>
    <el-header>
      <el-row type="flex" justify="center">
        <el-col :lg="14" :md="18">
          <el-row type="flex" justify="right" align="center">
            <el-col :span="6" :xl="10"
              ><img src="./assets/images/logo.png" alt="logo"
            /></el-col>
            <el-col :span="12" :xl="8" :offset="6">
              <ul class="nav-list">
                <li
                  :class="{ active: index == activeIndex }"
                  v-for="(item, index) in navList"
                  :key="item.id"
                  @click="changeItem(item, index)"
                >
                  {{ item.text }}
                </li>
              </ul>

              <!-- 移动端nav icon-->
              <div class="phone-nav" @click="drawer = true">
                <i class="el-icon-menu"></i>
              </div>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </el-header>
    <el-main>
      <transition name="el-fade-in" mode="out-in">
        <router-view></router-view>
      </transition>
    </el-main>

    <el-row class="footer">
      <el-col>
        <!-- <p>
          <pre>
 <router-link tag="a" :to="{ name: 'self' }">隐私政策</router-link>|关于我们|联系我们|Privacy Policy|家长监护</pre>
        </p> -->

        <nav>
          <router-link tag="a" :to="{ name: 'self' }">隐私政策</router-link>  <el-divider direction="vertical"></el-divider>
          <a href="#">关于我们</a>  <el-divider direction="vertical"></el-divider>
          <a href="#">联系我们</a>  <el-divider direction="vertical"></el-divider>
          <a href="#">家长监护</a>
        </nav>
        <p>抵制不良游戏，拒绝盗版游戏。 注意自我保护，谨防受骗上当。</p>
        <p>适度游戏益脑，沉迷游戏伤身。 合理安排时间，享受健康生活。</p>
      </el-col>
    </el-row>

    <!-- 弹出层 -->
    <el-drawer :visible.sync="drawer" size="150px" :with-header="false">
      <ul>
        <li
          :class="{ active: index == activeIndex }"
          v-for="(item, index) in navList"
          :key="item.id"
          @click="changeItem(item, index)"
        >
          {{ item.text }}
        </li>
      </ul>
    </el-drawer>
  </el-container>
</template>

<script>
export default {
  data() {
    return {
      drawer: false,
      activeIndex: 0,
      navList: [
        {
          id: 1,
          text: "主页",
          name: "Home",
        },
        {
          id: 2,
          text: "企业介绍",
          name: "About",
        },
        // {
        //   id: 3,
        //   text: "产品介绍",
        //   name: "Product",
        // },
        {
          id: 4,
          text: "合作",
          name: "Cooperation",
        },
        {
          id: 5,
          text: "招聘",
          name: "Job",
        },
      ],
    };
  },
  mounted() {
    let index = sessionStorage.getItem("activeIndex");
    index == undefined ? (this.activeIndex = 0) : (this.activeIndex = index);
  },
  methods: {
    changeItem(obj, i) {
      this.activeIndex = i;
      this.$router.push({ name: obj.name }).catch((err) => {
        console.log(err);
      });
      this.drawer = false;
      sessionStorage.setItem("activeIndex", i);
    },
  },
};
</script>

<style lang="less">
* {
  margin: 0;
  padding: 0;
}
li {
  list-style: none;
}

.el-container {
  display: flex;
  .el-header {
    background-color: #fff;
    height: 90px !important;
    border-bottom: 1px solid #eee;
    box-shadow: 0 0 5px 2px #eee;
    padding: 0 10px;
    .el-row {
      width: 100%;
      height: 100%;
      // border: 1px solid red;
      .el-col {
        img {
          // width: 100px;
          // height: 100px;
          height: 100%;
        }
        ul {
          display: flex;
          align-items: center;
          height: 100%;
          li {
            padding: 10px 0;
            border: 1px solid transparent;
            border-radius: 10px;
            cursor: pointer;
            color: #777;
            list-style: none;
            flex: 1;
            text-align: center;
            &.active {
              border: 1px solid #eb4b27;
              color: #eb4b27;
            }
          }
        }
        .phone-nav {
          border: 1px solid #eb4b27;
          color: #eb4b27;
          width: 30px;
          height: 30px;
          margin-left: 80%;
          margin-top: 15px;
          text-align: center;
          line-height: 30px;
          border-radius: 50%;
          display: none;
        }
      }
    }
  }
  .el-main {
    // border: 1px solid red;
  }
  .el-drawer {
    &:focus {
      outline: none;
    }
    ul {
      li {
        cursor: pointer;
        margin: 10px;
        color: #777;
        border: 1px solid #eee;
        padding: 10px 0;
        border-radius: 10px;
        text-align: center;
        &.active {
          border: 1px solid #eb4b27;
          color: #eb4b27;
        }
      }
    }
  }
  .footer {
    .el-col {
      background-color: #000;
      padding: 20px 0;
      nav {
        // border: 1px solid #00f;
        text-align: center;
        margin: 5px auto;
        width: 320px;
        display: flex;
        justify-content: center;
        font-size: 16px;
        a {
          color: #999;
          text-decoration: none;
          font-size: 14px;
        }
      }
      p {
        font-size: 12px;
        text-align: center;
        color: #999;
      }
    }
  }
}

pre {
  font-size: 16px;
}
@media screen and (max-width: 768px) {
  .el-container .el-header {
    height: 60px !important;
  }
}

@media screen and(max-width: 680px) {
  .el-main {
    padding: 5px !important;
    // border: 1px solid #000;
    // padding-bottom: 100px!important;
  }
  .el-container .nav-list {
    display: none !important;
  }
  .phone-nav {
    display: block !important;
  }
}


.el-image__inner--center {//ie10
    position: relative;
    top: 0!important;
    left: 0!important;
    transform: translate(0,0)!important;
}


</style>
